export const IS_LOADING_EMPLOYEES_VACATIONS = "IS_LOADING_EMPLOYEES_VACATIONS";
export const GET_EMPLOYEES_VACATIONS = "GET_EMPLOYEES_VACATIONS";
export const FAIL_EMPLOYEES_VACATIONS = "FAIL_EMPLOYEES_VACATIONS";

export const FAIL_UPDATE_EMPLOYEE_HALF_DAYS = "FAIL_UPDATE_EMPLOYEE_HALF_DAYS";
export const IS_LOADING_UPDATE_EMPLOYEE_HALF_DAYS = "IS_LOADING_UPDATE_EMPLOYEE_HALF_DAYS";
